import * as types from '../mutation-types'
import { api } from '@/modules/api/index'

const state = {
  newsList: null,
  segmentsList: []
}

const getters = {
  getNewsList: state => state.newsList,
  getSegmentsList: state => state.segmentsList
}

const actions = {
  async fetchNewsList ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.mailChimp.fetchNewsList(), payload)
      commit(types.SET_NEWS_LIST, data)
      return data
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Fail on fetch news list')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async editNewsList ({ dispatch, commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.put(api.mailChimp.updateNewsList(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'News list was updated successfully')
      return response.data
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Fail on news list updating')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchSegmentsList ({commit}, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.mailChimp.getSegmentsList(id))
      commit(types.SET_SEGMENTS_LIST, data)
    } catch (err) {
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_NEWS_LIST] (state, newsList) {
    state.newsList = newsList.mailChimpLists
  },
  [types.SET_SEGMENTS_LIST] (state, segmentsList) {
    state.segmentsList = segmentsList.mailChimpSegments
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/mail-chimp.js